import {
  Component,

  OnInit,
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CompanyService} from "../services/company-service/company-service";
import {CategoryService} from "../services/category/category.service";
import {MatHeaderRow} from "../../../node_modules/@angular/material/typings/table/row";
import {TranslateService} from "ng2-translate";
import {OrderBagVM} from "../models/OrderBagVM.model";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {PaymentResultVM} from "../models/PaymentResultVM.model";
import {PAYMENT_WEB_URL} from "../services/constants";
import {AlertService} from "../services/alert/alert.service";
import {Title, Meta} from '@angular/platform-browser';
import {CompanyVM} from "../models/CompanyVM.model";
import {ServantService} from "../services/servant-service/servant-service";
import {ServantVM} from "../models/ServiceItemDetailVM";
import {OrderBagItemVM} from "../models/OrderBagItemVM.model";
import * as momenttz from 'moment-timezone';

/**
 * We're loading this component asynchronously
 * We are using some magic with es6-promise-loader that will wrap the module with a Promise
 * see https://github.com/gdi2290/es6-promise-loader for more info
 */

@Component({
  selector: 'orderbag',
  template: require('./orderbag.template.html'),
  styles: [require('./orderbag.component.scss')]
})
export class OrderBagComponent implements OnInit {
  // public order_detail: OrderBagVM;
  public order_detail;
  public displayMessage = '';
  public status;
  public id;
  public userShouldPay = false;
  public totalPrice;
  public isLoaded = false;
  public authorityCode;
  public refid;
  public clientrefid
  public statusstr = '-';
  public jibimo_stateCode ;
  public jibimo_status ;
  public jibimo_trx ;
  public externalURL_fromWidget;
  company: CompanyVM;
  showServantName: boolean = false;
  public servant: ServantVM;
  public justShowSlotStartTime : boolean = false;
  public userCanPayOnline :boolean = false;

  constructor(private router: Router, private companyService: CompanyService,
              private alertService: AlertService,
              private categoryService: CategoryService,
              private orderBagService: OrderBagService,
              private activatedRoute: ActivatedRoute,
              private pageTitle: Title,
              private translate: TranslateService,
              private servantService: ServantService
  ) {

    translate.setDefaultLang('fa');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
  }

  public ngOnInit() {
    let parent = this;
    this.activatedRoute.queryParams.subscribe((params: Params) => {

      parent.id = params['id'];
      parent.authorityCode = params['Authority'];
      parent.refid = params['refid'];
      parent.clientrefid = params['clientrefid'];
      parent.status = params['Status'];
      parent.jibimo_stateCode = params['state_code'];
      parent.jibimo_status = params['status'];
      parent.jibimo_trx = params['trx'];


      parent.externalURL_fromWidget = params['URL'];
      if (parent.externalURL_fromWidget) {
        const el: HTMLElement = document.getElementById("main-header");
        el.style.display = 'none';
      }

      if(this.jibimo_trx)
        this.authorityCode = this.jibimo_trx;
      if(this.jibimo_status && this.jibimo_status == 1 )
        this.status = 'OK';

      if (parent.clientrefid)
        this.authorityCode = parent.clientrefid;
      if (this.authorityCode) {
        this.getOrderBagDetailByAuthority(this.authorityCode, this.refid);
      } else if (this.id) {
        this.getOrderBagDetail(this.id);
      }

      window.scrollTo(0, 0);


      //test
      // let jdate:Date = new Date();
      // let tehranTime    = momenttz.tz(jdate, "Asia/Tehran");
      // let isDST = tehranTime.isDST();
      // debugger;
      // alert(tehranTime);

    });

    this.companyService.getCompanyInfo().subscribe((c) => {
      parent.company = c;

      let accessMode = this.companyService.getCompanyCustomSetting(this.company, 'servant_list_access_mode');
      if (accessMode === 'MENU') {
        this.showServantName = true;
      }


      parent.justShowSlotStartTime = parent.companyService.getCompanyCustomSetting(c, 'justShowStartTime');

      if(c.hasActivePaymentGateway)
        parent.userCanPayOnline = true;

    })

  }

  public setStatusStr(status) {
    let parent = this;

    if (Number.isInteger(status)) {
      this.translate.get('orderBagStatus.STATUS_' + status).subscribe(function (st) {
        parent.statusstr = st;
      })
    }
  }

  private initData() {
    this.setServantInfo();
  }

  public getOrderBagDetail(id) {
    let parent = this;

    parent.orderBagService.getOrderBagDetailById(id).subscribe(detail => {
      parent.order_detail = detail;
      parent.order_detail.items.sort((val1, val2) => {
        return <any>new Date(val1.timesession.startDate) - <any>new Date(val2.timesession.startDate);
      })
      parent.computeOrderbagPrice(detail);
      if (detail.status == 0)
        this.isLoaded = false;
      parent.setStatusStr(detail.status);
      parent.initData();
      parent.confirmOrderBag();
      //  parent.displayMessage = parent.makeDisplayMessage(detail);
      this.setPageTitle();
      if (parent.order_detail.imageAlbum)
        parent.companyService.getAlbumImageList(parent.order_detail.imageAlbum).subscribe((imageList) => {
          if (imageList && imageList.length > 0)
            parent.order_detail.coverImage = imageList[0];
        })
    })
  }

  public cancelReserve() {
    let parent = this;

    if (confirm('از لغو رزرو خود اطمینان دارید؟')) {
      this.orderBagService.cancelReserve(this.id).then(function () {
        parent.getOrderBagDetail(parent.id);
      }).catch(function () {
        alert('خطا در لغو رزرو')
      });
    }
  }

  private makeDisplayMessage(detail: OrderBagVM): string {
    let message = "";
    message = this.translate.instant("orderBagStatusDesc.STATUS_" + detail.status);

    return message;

  }


  private getOrderBagDetailByAuthority(authority, refid) {
    this.orderBagService.getOrderBagByAuthorityCode(authority, refid).subscribe((orderbag) => {

      if (orderbag) {
        this.id = orderbag.id;
        this.getOrderBagDetail(orderbag.id);
      }
    })

  }

  confirmOrderBag() {
    let parent = this;
    if (parent.order_detail) {
      //  alert(parent.isFreeOrderBag);
      if (!parent.authorityCode && parent.order_detail.status == 0) {
        parent.isLoaded = false;
        parent.orderBagService.confirmFreeOrderBagPayment(parent.id).then((res) => {
          parent.refreshFormData(parent.id)

        }).catch((er) => {


        });

      } else {
        if (parent.authorityCode && parent.status == 'OK')
          parent.orderBagService.confirmOrderBagPayment(parent.authorityCode, parent.refid).then((res) => {

            parent.router.navigateByUrl('/booked?id=' + this.id);

          }).catch((er) => {
          });
      }


    }
  }

  refreshFormData(id) {
    let parent = this;
    this.orderBagService.getOrderBagDetailById(id).subscribe(detail => {
      parent.order_detail = detail;
      parent.displayMessage = this.makeDisplayMessage(detail);
      parent.isLoaded = true;
      parent.setStatusStr(detail.status);
      parent.initData();
      if (this.order_detail.imageAlbum)
        this.companyService.getAlbumImageList(this.order_detail.imageAlbum.id).subscribe((imageList) => {
          if (imageList && imageList.length > 0)
            this.order_detail.coverImage = imageList[0];
        })
    })
  }

  payOnline() {
    let parent = this;

    parent.orderBagService.getOrderBagById(this.order_detail.orderbagid).subscribe(order => {
      parent.orderBagService.payOrderBag(order).then(payment => {
        parent.gotoPayment(payment);
      }).catch((er) => {

        this.alertService.showErrorMessage(er);
      });

    });

  }

  goToAP(token) {
    // console.log("authority : "+ token);
    //remove "
    token = token.replace(/"/g, '');

    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://asan.shaparak.ir');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'RefId');
    hiddenField.setAttribute('value', token);
    form.appendChild(hiddenField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  goToSEP(token) {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://sep.shaparak.ir/onlinepg/onlinepg');
    // form.setAttribute('action', 'https://consult.planovin.com/#/testReturnUrl');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'Token');
    hiddenField.setAttribute('value', token);
    form.appendChild(hiddenField);

    const hiddenField2 = document.createElement("input");
    hiddenField2.setAttribute("name", "GetMethod");
    hiddenField2.setAttribute("value", "true");
    form.appendChild(hiddenField2);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  private gotoPayment(res: PaymentResultVM): void {

    console.log("GO TO PAYMENT")
    setTimeout(() =>{
      if (res.free) {
        this.router.navigateByUrl('/booked?id=' + res.orderBagId);
      }
      else if (res.payUrl) {
        if(res.gatewayType == "SUPPLIER_AP" && res.refId) {
          this.goToAP(res.refId);
        }
        else if(res.gatewayType == "SUPPLIER_SEP" && res.refId) {
          this.goToSEP(res.refId);
        }
        else window.location.href = res.payUrl;
      }
    },3000)

  }

  computeOrderbagPrice(detail) {
    detail.id = detail.orderbagid;

    this.orderBagService.computeOrderbagPrice(detail).subscribe((tp) => {
      this.totalPrice = tp;
      if (this.totalPrice.onlinePaymentAmount > 0 && (detail.status == 0 || detail.status == 6))
      //if (this.totalPrice.onlinePaymentAmount > 0 )
        this.userShouldPay = true;
      else
        this.userShouldPay = false;
    });
  }

  public setPageTitle() {
    let title = "رزرو" + " : " + this.order_detail.id + " - " + this.order_detail.serviceTitle;
    this.pageTitle.setTitle(title);
  }

  private setServantInfo() {
    if (!this.order_detail.servantId)
      return;
    this.servantService.getServantById(this.order_detail.servantId).subscribe(result => {
      this.servant = result;
    })

  }

  public removeOrderBagItem(item) {

    if(item && item.orderBagItemId) {
      let parent = this;

      if (confirm('از حذف این آیتم از رزرو خود اطمینان دارید؟')) {
        this.orderBagService.removeOrderBagItem(item.orderBagItemId).then(function () {
          parent.getOrderBagDetail(parent.id);
        }).catch(function () {
          alert('خطا در لغو آیتم')
        });
      }
    }
  }

  public canBeCancelItem(item){
      let now = new Date();
      if(item.timesession.startTime > now.toISOString())
        return true;
    return false;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+orderbag/orderbag.component.ts